import {
  Accordion,
  AccordionToggle,
  AccordionCollapse,
  AccordionToggleProps,
} from "@stadium/ui/src/components/accordion/bootstrap-accordion/styled";

export const PanelLabel = ({
  children,
  id,
  ...rest
}: Omit<AccordionToggleProps, "eventKey"> & {
  id: AccordionToggleProps["eventKey"];
}) => (
  <AccordionToggle eventKey={id} {...rest}>
    {children}
  </AccordionToggle>
);

export const Panel = Accordion;

export const PanelCollapsibleArea = AccordionCollapse;
